import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {RootState} from 'typesafe-actions';

const STORAGE_KEY = 'sei_redux_state';
const onchange = new Subject();
const storeSubject = new Subject<RootState>();

export const storeListener = (store: any): Subject<RootState> => {
  store.subscribe(() => onchange.next(0));

  onchange.pipe(debounceTime(3000)).subscribe(() => {
    storeSubject.next(store.getState());
  });

  storeSubject.subscribe(saveState);

  return storeSubject;
};

export const loadState = (): RootState | undefined => {
  try {
    const serializedState = sessionStorage.getItem(STORAGE_KEY);

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.error('error on load state', err);
    return undefined;
  }
};

export const saveState = (state: RootState): void => {
  try {
    const serializedState = JSON.stringify(filterState(state));
    sessionStorage.setItem(STORAGE_KEY, serializedState);
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.error('error on save state', err);
  }
};

function filterState(state: RootState): any {
  const {user} = state.auth;
  const {loaded} = state.system;
  const {model} = state.election;

  return {
    auth: {user},
    election: {model},
    system: {loaded},
  };
}



// WEBPACK FOOTER //
// ./src/store/freeze.ts